/**
 * Возврат со страницы оплаты YooKassa (booking-controller#pay, return_url).
 * Сама модалка бронирования требует quest/slot из клика по расписанию, которых
 * у нас на чистой загрузке страницы нет — поэтому показываем отдельный
 * баннер-уведомление, а не пытаемся открыть модалку в шаге "успех".
 */
export function initBookingPaymentReturn(): void {
  const params = new URLSearchParams(window.location.search)
  if (params.get('payment') !== 'return' || !params.get('booking_id')) return

  params.delete('payment')
  params.delete('booking_id')
  const query = params.toString()
  const url =
    window.location.pathname + (query ? `?${query}` : '') + window.location.hash
  window.history.replaceState(null, '', url)

  const banner = document.createElement('div')
  banner.setAttribute(
    'style',
    'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:9999;' +
      'max-width:min(90vw,480px);padding:16px 20px;border-radius:12px;' +
      'background:#c2410c;color:#fff;font-size:14px;line-height:1.4;' +
      'box-shadow:0 8px 24px rgba(0,0,0,.2);'
  )
  banner.textContent =
    'Оплата бронирования пока не подтверждена. Если вы уже оплатили — подтверждение придёт на почту в течение нескольких минут.'
  document.body.appendChild(banner)

  window.setTimeout(() => banner.remove(), 10000)
}
